import { createClient } from "@supabase/supabase-js";

// Browser client — anon key only. RLS protects all data; no service-role key or
// Meta/Pipeboard token ever reaches the browser.
const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anon) {
  // Surface misconfiguration early rather than failing cryptically on first call.
  // eslint-disable-next-line no-console
  console.error("Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY in web/.env");
}

export const supabase = createClient(url, anon, {
  auth: { persistSession: true, autoRefreshToken: true },
});
